import { LOGIN_PATH, LOGOUT_PATH, SILENT_LOGIN_PATH } from '@/app/api/auth/[auth0]/constants';
import { Routes } from '@/constants';

export type AuthPath = (typeof AUTH0_PATH)[keyof typeof AUTH0_PATH];

export const AUTH0_PATH = {
  LOGIN: `/api/auth/${LOGIN_PATH}`,
  LOGOUT: `/api/auth/${LOGOUT_PATH}`,
  SILENT_LOGIN_PATH: `/api/auth/${SILENT_LOGIN_PATH}`,

  // Custom
  ERROR_PATH: Routes.AUTH_ERROR,
} as const;
